import { mergeAll } from './mergeAll';
export function concatAll() {
  return mergeAll(1);
}